import { render, staticRenderFns } from "./tramitados.vue?vue&type=template&id=23f25824"
import script from "./tramitados.vue?vue&type=script&lang=js"
export * from "./tramitados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports